/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import { Button, LinkButton, SplashScreenAlternativeButton, SPACING_S } from '@veeam/components';
import styled from 'styled-components';

export const LoginButton = styled(Button)`
    min-width: 112px;
`;

export const StyledLinkButton = styled(LinkButton)`
    margin-top: ${SPACING_S};
`;

export const AlternativeButton = styled(SplashScreenAlternativeButton)`
    min-width: 264px;
`;
